/* eslint-disable @typescript-eslint/explicit-function-return-type */
import SendIcon from '@mui/icons-material/Send';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmployeeUploadFormat from '../../../assets/formatfiles/AddEmployeeFormat.xlsm';
import {
  Box,
  Typography,
  useTheme,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import {
  type GridEventListener,
  type GridColumns,
  type GridValidRowModel,
  type GridRowParams,
  type MuiEvent,
  type GridSortModel,
} from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { type ChangeEvent, Fragment, useEffect, useState } from 'react';
import {
  getAllOrganizationEmployeeDetails,
  getAllOrganizationEmployeeWithRoleName,
  removeOrganizationEmployee,
  resendInviteLinkToOrgAdminEmployee,
  resendInviteLinkToOrgEmployee,
  uploadFileDataValidation,
  uploadFileDataCreation,
  uploadFileDataEmailCreation,
  reRegisterOrganizationEmployee,
} from 'service/UserService';
import { colorTheme } from '../../../theme';
import { AlertModal, CustomDataGrid, DialogBox } from 'components';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { type IEmployeeProps } from 'types';
import { type EmployeeInfo, type OrganizationInfo } from 'types/pages';
import { useDispatch, useSelector } from 'react-redux';
import { type RootState } from 'store/rootReducer';
import { setOrganizationInfo, setOnboardedEmail } from 'store/employeeDetails';
import Buttons from 'components/elements/Buttons';
import ErrorDialog from './uploadError';
import EditIcon from '@mui/icons-material/Edit';
import CreateEmployee, {
  type IEmployeeInfo,
} from 'pages/Employer/Employees/CreateEmployee';
import { strings } from 'i18n/Strings';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import {
  activeStatusOptions,
  commonConstantTexts,
  employeeStatusOptions,
  orgEmployeeConstants,
} from 'constants/constantText';
import {
  setCurrentPage,
  setSortBy,
  setSortOrder,
} from 'store/component/pagination';
import { checkSortingValues } from 'utils/GeneralUtil';
import ConfirmationModal from 'components/confirmation-modal';
import * as XLSX from 'xlsx';

type GridRowData = Record<string, unknown>;
interface empType {
  typeIs?: string;
}
const EmployeeGrid = (props: empType): JSX.Element => {
  const { typeIs } = props;
  const navigate = useNavigate();
  const routerName = useLocation();
  const dispatch = useDispatch();
  const { organizationInfo, onboardedEmails } = useSelector(
    (state: RootState) => state.employeeDetails,
  );
  const { empId } = useSelector((state: RootState) => state.onboarding);
  const { orgId } = useParams();
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);
  const [employeeData, setEmployeeData] = useState<IEmployeeProps[] | unknown>(
    [],
  );
  const [employeeDataFile, setEmployeeDataFile] = useState<File | null>();
  const [updateEmployeeId, setUpdateEmployeeId] = useState('');
  const [openFileUploadDialog, setOpenFileUploadDialog] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessages] = useState<string[]>([]);
  const [openErrorMessageDialog, setOpenErrorMessageDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [openAddEmployee, setOpenAddEmployee] = useState(false);
  const [openEmployeeForm, setOpenEmployeeForm] = useState(false);
  const [openUploadOptions, setOpenUploadOptions] = useState(false);
  const [, setEmployeeDashboardData] = useState<EmployeeInfo[]>();
  const [, setIsEmpty] = useState(false);
  const [isFromDashboard, setIsFromDashboard] = useState(false);
  const [toBeDeletedEmployee, setToBeDeletedEmployee] = useState('');
  const [toBeReRegisteredEmployee, setToBeReRegisteredEmployee] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openReregisterDialog, setOpenReregisterDialog] = useState(false);
  const [comments, setComments] = useState('');
  const [pageCount, setPageCount] = useState(null);
  const [disabledInviteButtons, setDisabledInviteButtons] = useState({});
  const [openCommentDialog, setOpenCommentDialog] = useState({
    isOpen: false,
    status: '',
  });
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedData, setSelectedData] = useState<
    GridValidRowModel | undefined
  >();
  const [showError, setShowError] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [uploadFileStaus, setUploadFileStaus] = useState('');

  const pageInfo = useSelector((state) => state?.pagination?.employees);
  const getOrgEmployeeData = (): void => {
    if (orgId) {
      getAllOrganizationEmployeeWithRoleName({
        id: orgId,
        page: Number(pageInfo?.page) + 1,
        size: pageInfo?.pageSize,
        sortBy: pageInfo?.sortBy,
        sortOrder: pageInfo?.sortOrder,
        searchValue,
      })
        .then((res) => {
          if (typeof res !== 'undefined' && 'employees' in res) {
            const { employees, count } = res as unknown as {
              employees: IEmployeeProps[];
              count: number;
            };
            if (employees) {
              setEmployeeData(employees);
              setPageCount(count);
            }
          }
        })
        .catch((err: Error) => {
          throw err;
        });
    }
  };

  const getTotalEmployeeData = async (): Promise<void> => {
    if (orgId && organizationInfo === null) {
      setIsEmpty(false);

      await getAllOrganizationEmployeeDetails(orgId)
        .then((res) => {
          if (typeof res !== 'undefined' && 'orgInfo' in res) {
            const { orgInfo } = res as { orgInfo: OrganizationInfo };

            if (orgInfo) {
              setEmployeeDashboardData(orgInfo.orgEmployee);
              const emails = orgInfo?.user
                ? orgInfo?.user?.map((e) => e.email)
                : [];
              dispatch(setOnboardedEmail(emails));
              dispatch(setOrganizationInfo(orgInfo));
            } else {
              setIsEmpty(true);
            }
          }
        })
        .catch((err: Error) => {
          throw err;
        });
    }
  };
  useEffect(() => {
    if (routerName.pathname.includes('/empoyees-chart-details')) {
      void getTotalEmployeeData();
      setIsFromDashboard(true);
    } else {
      getOrgEmployeeData();
    }
  }, [
    pageInfo?.page,
    pageInfo?.pageSize,
    pageInfo?.sortBy,
    pageInfo?.sortOrder,
    searchValue,
  ]);
  useEffect(() => {
    if (organizationInfo) {
      if (typeIs === 'Total Employees') {
        setEmployeeData(organizationInfo?.orgEmployee);
      } else if (typeIs === 'Onboarded Employees') {
        setEmployeeData(
          organizationInfo?.orgEmployee?.filter((x: EmployeeInfo) =>
            onboardedEmails.includes(x?.email ?? ''),
          ),
        );
      } else if (typeIs === 'Not Onboarded  Employees') {
        setEmployeeData(
          organizationInfo?.orgEmployee?.filter(
            (x: EmployeeInfo) => !onboardedEmails.includes(x?.email ?? ''),
          ),
        );
      }
    }
  }, [organizationInfo, typeIs]);

  const handleDelete = async (): Promise<void> => {
    if (toBeDeletedEmployee) {
      const res = await removeOrganizationEmployee(
        Number(toBeDeletedEmployee.orgEmpId),
        comments,
        toBeDeletedEmployee?.status,
      ); // convert to number
      if (res) {
        dispatch(
          setSnackBarSuccess({
            snackBarMessage: strings.displayText.employeeSuccessMessage,
          }),
        );
      } else {
        dispatch(
          setSnackBarFailed({
            snackBarMessage: strings.displayText.employeeFailedMessage,
          }),
        );
      }

      res && getOrgEmployeeData();
      setOpenDeleteDialog(false);
    }
  };

  const handleReRegister = async (): Promise<void> => {
    try {
      if (toBeReRegisteredEmployee) {
        const success = await reRegisterOrganizationEmployee(
          toBeReRegisteredEmployee.orgEmpId,
          comments,
          toBeReRegisteredEmployee?.status,
        );
        if (success) {
          toBeReRegisteredEmployee.status = 'Registered';
          dispatch(
            setSnackBarSuccess({
              snackBarMessage:
                strings.displayText.employeeReRegisterSuccessMessage,
            }),
          );
          setOpenReregisterDialog(false);
          setOpenCommentDialog({ isOpen: false, status: '' });
        } else {
          dispatch(
            setSnackBarFailed({
              snackBarMessage:
                strings.displayText.employeeReRegisterFailedMessage,
            }),
          );
        }
        success && getOrgEmployeeData();
      }
    } catch (error) {
      console.error('Error occurred during re-registration:', error);
    }
  };

  const uploadEmployeeDataFile = async (
    file: File,
    orgId: number,
  ): Promise<void> => {
    // try {
    if (file) {
      setLoader(true);
      setUploadFileStaus('Reading file contents...!');
      if (!file) return;

      const reader = new FileReader();

      reader.onload = async (evt: unknown) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });

        const sheetName = workbook.SheetNames[0]; // read first sheet
        const sheet = workbook.Sheets[sheetName];

        const json = XLSX.utils.sheet_to_json(sheet, { defval: '' }); // defval prevents `undefined`

        setUploadFileStaus('Running validation checks...!');
        await uploadFileDataValidation(json, orgId, empId)
          .then(async () => {
            setUploadFileStaus('Data verified. Creating new user records...');
            await uploadFileDataCreation(json, orgId, empId)
              .then(async () => {
                setUploadFileStaus(
                  'User accounts created. Dispatching email notifications...',
                );
                await uploadFileDataEmailCreation(
                  json.map((a: unknown) => ({ email: a['Email*'] })),
                  orgId,
                  empId,
                );
                setLoader(false);
                setSuccessMessage(
                  strings.displayText.employeeAddSuccessMessage,
                );
                getOrgEmployeeData();
              })
              .catch((err) => {
                console.log(err);
                setLoader(false);
                setOpenFileUploadDialog(false);
              });
            setSuccessMessage(strings.displayText.employeeAddSuccessMessage);
          })
          .catch((error) => {
            if (error?.response?.data?.data?.length > 0) {
              setShowError(true);
              setErrorData(error.response.data.data);
            }
            setErrorMessages(error?.response?.data?.message.split(','));
            setOpenErrorMessageDialog(true);
            setLoader(false);
            setOpenFileUploadDialog(false);
          });
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleClose = (_event: object, reason: string) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    setOpenFileUploadDialog(false);
  };

  const handleSelectStatus = (event, row): void => {
    event.stopPropagation();
    if (event.target.value === commonConstantTexts.leaver) {
      setOpenDeleteDialog(true);
      setToBeDeletedEmployee({ ...row, status: event.target.value });
    } else {
      setOpenReregisterDialog(true);
      setToBeReRegisteredEmployee({ ...row, status: event.target.value });
    }
  };

  const handleCreateDialogClose = (): void => {
    if (updateEmployeeId) {
      setOpenEmployeeForm(false);
    } else {
      setConfirmationModal(true);
    }
  };

  const handleCloseEmployeeForm = (): void => {
    setOpenEmployeeForm(false);
  };

  const handleConfirmationModal = (): void => {
    setConfirmationModal(false);
    setOpenEmployeeForm(false);
  };

  const handleConfirmationModalContinue = (): void => {
    setConfirmationModal(false);
  };

  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'firstName',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.firstName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.firstName} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {row.firstName}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'lastName',
      width: 120,

      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.lastName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.lastName} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {row.lastName}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'email',
      width: 220,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.emailAddress}
        </Typography>
      ),
      renderCell: ({ row }) => {
        return (
          <Tooltip title={row?.email} placement="top">
            <Typography
              variant="h5"
              color={colors.gray[100]}
              fontSize={14}
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 190,
                display: 'block',
              }}
            >
              {row?.email}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'phone',
      width: 180,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.phoneNumber}
        </Typography>
      ),
      renderCell: ({ row }) => {
        let displayPhone = row.phone !== '' ? row.phone : '-';
        if (displayPhone.startsWith('++')) {
          displayPhone = displayPhone.substring(1);
        }
        return (
          <Tooltip title={displayPhone || '-'} placement="top">
            <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
              {displayPhone}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'resendInvite',
      headerName: strings.displayText.resendInvite,
      headerAlign: 'center',
      sortable: false,
      width: 150,
      renderCell: ({ row }) => (
        <Box m="0 auto" display="flex" justifyContent="space-evenly">
          {row.status === 'Not Registered' ||
          (row.status === 'Registered' && row.emailSubscription === true) ? (
            <Button
              sx={{ padding: '4px 5px' }}
              variant="outlined"
              color="success"
              disabled={
                disabledInviteButtons[row.orgEmpId || row.empId] !== undefined
              }
              onClick={(e) => {
                e.stopPropagation();

                void handleResentInvite({
                  empType: row.orgEmpId
                    ? orgEmployeeConstants.orgEmpId
                    : orgEmployeeConstants.empId,
                  empId: row.orgEmpId || row.empId,
                });
              }}
              endIcon={<SendIcon />}
            >
              {disabledInviteButtons[row.orgEmpId || row.empId] !== undefined
                ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  `Wait ${disabledInviteButtons[row.orgEmpId || row.empId]}s`
                : strings.displayText.invite}
            </Button>
          ) : (
            <Button
              sx={{ padding: '4px 5px' }}
              variant="outlined"
              color="success"
              disabled={true}
              endIcon={<SendIcon />}
            >
              {strings.displayText.invite}
            </Button>
          )}
        </Box>
      ),
    },
    {
      field: 'status',
      width: 180,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.registration}
        </Typography>
      ),
      renderCell: ({ row }) => {
        return (
          <FormControl fullWidth>
            <Select
              margin="normal"
              label="Status"
              value={row.status}
              onChange={(event: unknown) => {
                handleSelectStatus(event, row);
              }}
            >
              {employeeStatusOptions.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.value}
                  disabled={
                    row.status === 'Leaver' ? false : option.value !== 'Leaver'
                  }
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: 'active_status',
      sortable: false,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.status}
        </Typography>
      ),
      width: 75,
      renderCell: ({ row }) => {
        return (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {activeStatusOptions.find((a) => a.value === row.activeStatus)
              ?.label ?? '-'}
          </Typography>
        );
      },
    },
  ];

  const handleEvent: GridEventListener<'rowClick'> = (
    params: GridRowParams, // GridRowParams
    event: MuiEvent<React.MouseEvent<HTMLElement>>, // MuiEvent<React.MouseEvent<HTMLElement>>
  ) => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    if (
      params?.row?.status === orgEmployeeConstants.leaver ||
      params?.row?.status === orgEmployeeConstants.notRegistered
    ) {
      setOpenCommentDialog({ isOpen: true, status: params?.row?.status });
      setComments(params?.row?.comments);
    } else if (params?.row?.status === orgEmployeeConstants.registered) {
      setOpenCommentDialog({
        isOpen: true,
        status: orgEmployeeConstants.registered,
      });
    } else {
      event.preventDefault();
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const { userId }: { userId: number } = params?.row;
      navigate(`/employees-details/${userId}`);
    }
  };

  const AddEmployeeChoices = (): JSX.Element => {
    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
      >
        <Buttons
          sx={{ m: 2, width: '450px', bgcolor: colors.greenAccent[500] }}
          onClick={() => {
            setOpenEmployeeForm(true);
            setOpenAddEmployee(false);
          }}
        >
          {strings.displayText.createEmployee}
        </Buttons>
        <Buttons
          sx={{ m: 2, width: '450px', bgcolor: colors.greenAccent[500] }}
          onClick={() => {
            setOpenUploadOptions(true);
            setOpenAddEmployee(false);
          }}
        >
          {strings.displayText.uploadFile}
        </Buttons>
      </Box>
    );
  };

  const UploadChoices = (): JSX.Element => {
    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
      >
        <Button
          sx={{
            m: 1,
            bgcolor: colors.greenAccent[500],
            color: '#fff',
            '&:hover': {
              bgcolor: colors.greenAccent[500],
            },
          }}
          startIcon={<DownloadIcon />}
        >
          <a
            style={{ textDecoration: 'none', color: '#fff' }}
            href={EmployeeUploadFormat}
            target="_blank"
            download="Add Employee - Format"
            rel="noreferrer"
          >
            {strings.displayText.downloadFormat}
          </a>
        </Button>
        <Button
          sx={{
            m: 2,
            bgcolor: colors.greenAccent[500],
            color: '#fff',
            '&:hover': {
              bgcolor: colors.greenAccent[500],
            },
          }}
          startIcon={<UploadIcon />}
          component="label"
        >
          {strings.displayText.uploadData}
          <input
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.files) {
                setEmployeeDataFile(e.target.files[0]);
                void uploadEmployeeDataFile(e.target.files[0], Number(orgId));
                setOpenUploadOptions(false);
                setOpenFileUploadDialog(true);
              }
            }}
            hidden
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            type="file"
          />
        </Button>
      </Box>
    );
  };

  const handleResentInvite = async (employee: {
    empType: string;
    empId: number;
  }): Promise<void> => {
    try {
      const resendFunction =
        employee.empType === orgEmployeeConstants.orgEmpId
          ? resendInviteLinkToOrgEmployee
          : resendInviteLinkToOrgAdminEmployee;
      await resendFunction(employee.empId).then((res) => {
        if (res) {
          setDisabledInviteButtons((prev) => ({
            ...prev,
            [employee.empId]: 30,
          }));
          const interval = setInterval(() => {
            setDisabledInviteButtons((prev: unknown) => {
              if (prev[employee.empId] > 1) {
                return { ...prev, [employee.empId]: prev[employee.empId] - 1 };
              } else {
                clearInterval(interval);
                const { [employee.empId]: _, ...rest } = prev; // Remove key after countdown
                return rest;
              }
            });
          }, 1000);
          dispatch(
            setSnackBarSuccess({
              snackBarMessage: strings.displayText.intiveSentSuccess,
            }),
          );
        }
      });
    } catch (error) {
      console.log(error);
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.intiveSentFailed,
        }),
      );
    }
  };

  const handleSearch = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    setSearchValue(event.target.value);
    dispatch(setCurrentPage({ key: 'employees', value: 0 }));
  };

  const handleSortChange = (model: GridSortModel): void => {
    dispatch(
      setSortBy({
        key: 'employees',
        value: model[0].field,
      }),
    );
    dispatch(setSortOrder({ key: 'employees', value: model[0].sort }));
    dispatch(setCurrentPage({ key: 'employees', value: 0 }));
  };

  return (
    <Fragment>
      {isFromDashboard ? (
        <CustomDataGrid
          title=""
          columns={columns}
          rows={employeeData as GridRowData[]}
          onRowClick={handleEvent}
          getRowId={(row: IEmployeeProps) =>
            `${String(row.empId)}${row.email ? row.email : ''}`
          }
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          pageCount={pageCount}
          currentPage="employees"
        />
      ) : (
        <Box>
          <CustomDataGrid
            title="Employee"
            columns={columns}
            searchEnabled={true}
            handleSearch={handleSearch}
            addButtonTitle={strings.displayText.addEmpoyeeLabel}
            onAddButtonClick={() => {
              setOpenAddEmployee(true);
              setUpdateEmployeeId('');
              // ref.current?.focus();
            }}
            pageCount={pageCount}
            actionBtnText1="edit"
            ActionBtnIcon1={() => <EditIcon />}
            onActionBtnClick1={(row, event) => {
              if (row.status === 'Leaver') return;
              event.stopPropagation();
              setOpenEmployeeForm(true);
              setUpdateEmployeeId(row?.orgEmpId || row?.empId);
              setSelectedData(row);
            }}
            rows={employeeData as GridRowData[]}
            onRowClick={handleEvent}
            getRowId={(row: IEmployeeProps) =>
              `${String(row.empId)}${row.email ? row.email : ''}`
            }
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
            }
            currentPage="employees"
            sortModel={checkSortingValues(pageInfo)}
            sortingMode={strings.displayText.sortingServer}
            onSortModelChange={(mode) => {
              handleSortChange(mode);
            }}
            searchPlaceholder={strings.displayText.searchLabel1}
          />
          <DialogBox
            open={openAddEmployee}
            onClose={() => {
              setOpenAddEmployee(false);
            }}
            screenWidth={'lg'}
            title={strings.displayText.addEmployeeModelTitle}
          >
            <AddEmployeeChoices />
          </DialogBox>
          <DialogBox
            open={openEmployeeForm}
            onClose={handleCreateDialogClose}
            screenWidth={'md'}
            title={
              updateEmployeeId
                ? strings.displayText.editEmployee
                : strings.displayText.createEmployee
            }
          >
            <CreateEmployee
              organizationId={orgId}
              updateEmployeeId={updateEmployeeId}
              updateEmployeeData={getOrgEmployeeData}
              onClose={handleCloseEmployeeForm}
              selectedData={selectedData as IEmployeeInfo}
            />
          </DialogBox>
          <ConfirmationModal
            open={confirmationModal}
            onClose={handleConfirmationModal}
            onContinue={handleConfirmationModalContinue}
          />
          <DialogBox
            open={openUploadOptions}
            onClose={() => {
              setOpenUploadOptions(false);
            }}
            screenWidth={'md'}
            title={strings.displayText.upload}
          >
            <UploadChoices />
          </DialogBox>
          <Dialog
            disableEscapeKeyDown
            open={openFileUploadDialog}
            onClose={handleClose}
          >
            {openFileUploadDialog && loader && (
              <Box>
                <Box sx={{ m: 3 }}>
                  <Typography sx={{ mt: 1 }}>
                    {employeeDataFile?.name}
                  </Typography>
                  <LinearProgress sx={{ m: 2 }} />
                  <Typography sx={{ mt: 1 }}>{uploadFileStaus}</Typography>
                </Box>
              </Box>
            )}
            {openFileUploadDialog && !loader && successMessage && (
              <Box sx={{ m: 5 }} display={'flex'} flexDirection={'column'}>
                <Box sx={{ alignSelf: 'center' }}>
                  <CheckCircleIcon
                    fontSize={'large'}
                    htmlColor={colors.greenAccent[500]}
                  />
                </Box>
                <Typography sx={{ m: 1, fontWeight: '900', fontSize: '20' }}>
                  {strings.displayText.uploadSucessfull}
                </Typography>

                <Button
                  sx={{
                    m: 2,
                    bgcolor: colors.greenAccent[500],
                    color: '#fff',
                    '&:hover': {
                      bgcolor: colors.greenAccent[500],
                    },
                  }}
                  onClick={() => {
                    setOpenFileUploadDialog(false);
                  }}
                >
                  {strings.displayText.closeLable}
                </Button>
              </Box>
            )}
          </Dialog>
          {errorMessage.length > 0 && (
            <Dialog
              disableEscapeKeyDown
              open={openErrorMessageDialog}
              onClose={() => {
                setOpenErrorMessageDialog(false);
              }}
            >
              <DialogContent>
                <Box display={'flex'} flexDirection={'column'}>
                  <Typography alignSelf={'center'} fotntWeight={'700'}>
                    {strings.displayText.uploadFailed}
                  </Typography>
                  {errorMessage.map((message, index) => (
                    <Typography key={index} sx={{ mt: 1, color: 'red' }}>
                      - {message}
                    </Typography>
                  ))}
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setEmployeeDataFile(null);
                    setErrorMessages([]);
                    setOpenUploadOptions(true);
                    setOpenErrorMessageDialog(false);
                  }}
                  startIcon={<RefreshIcon />}
                  variant="text"
                  sx={{ color: colors.greenAccent[500], fontWeight: 'bold' }}
                >
                  {strings.displayText.tryAgain}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Box>
      )}
      <AlertModal
        isOrganizationEmployee={true}
        comments={comments}
        setComments={setComments}
        open={openDeleteDialog}
        onClose={() => {
          setOpenDeleteDialog(false);
        }}
        handleConfirm={handleDelete}
        title={`${
          strings.displayText.deleteConfirmationBAdminText
        } employee ${String(toBeDeletedEmployee?.email)}`}
        isButtonForConfirmation={true}
      />
      {openCommentDialog.status !== 'Registered' && (
        <Dialog
          open={openCommentDialog.isOpen}
          onClose={() => {
            setOpenCommentDialog({ isOpen: false, status: '' });
          }}
        >
          <DialogContent>
            <Typography
              variant="h4"
              component="h2"
              sx={{ textAlign: 'center' }}
            >
              {openCommentDialog.status === 'Leaver'
                ? 'The employee is Leaver.'
                : 'The employee is not Registered.'}
            </Typography>
            {comments ? (
              <Typography
                mt={2}
                component="h1"
                variant="h5"
                style={{ fontSize: '16px' }}
              >
                {' '}
                {strings.displayText.comments} : {comments}
              </Typography>
            ) : (
              <Typography
                mt={2}
                component="h1"
                variant="h5"
                style={{ fontSize: '16px' }}
              >
                {strings.displayText.noCommentsProvid}
              </Typography>
            )}
          </DialogContent>
        </Dialog>
      )}

      <AlertModal
        isOrganizationEmployee={true}
        setComments={setComments}
        open={openReregisterDialog}
        onClose={() => {
          setOpenReregisterDialog(false);
        }}
        handleReRegister={handleReRegister}
        title={`${
          strings.displayText.reRegisterConfirmationText
        } employee ${String(toBeReRegisteredEmployee?.email)}?`}
        isButtonForReregister={true}
      />

      {openCommentDialog.status !== 'Registered' && (
        <Dialog
          open={openCommentDialog.isOpen}
          onClose={() => {
            setOpenCommentDialog({ isOpen: false, status: '' });
          }}
        >
          <DialogContent>
            <Typography
              variant="h4"
              component="h2"
              sx={{ textAlign: 'center' }}
            >
              {openCommentDialog.status === 'Not Registered'
                ? 'The employee is not Registered.'
                : 'The employee is Leaver'}
            </Typography>
          </DialogContent>
        </Dialog>
      )}
      <ErrorDialog
        isModalOpen={showError}
        errData={errorData}
        handleCreateDialogClose={() => {
          setShowError(false);
          setErrorData([]);
        }}
      />
    </Fragment>
  );
};

export default EmployeeGrid;
